import { Box, Typography, Button, styled, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, OutlinedInput, DialogActions, Tooltip, FormHelperText, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import LinkIcon from '@mui/icons-material/Link';
import { useState } from "react";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { useSelector } from "react-redux";
import { apiRequest } from "../../../../common/common";
import { ThreeDAccess, TwoDAccess } from "../../../../common/const";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const Cell = styled(TableCell)({
    padding: '0px 0px 0px 20px'
});
export default function Resources({
    setResource,
    rows,
    setRows,
    detailsData,
    setDetailsData,
    setSkuNo
}) {
    const { roles, user } = useSelector(state => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [url, setUrl] = useState(null);
    const [isValid, setIsValid] = useState(true);

    const getAcceptType = (fileType) => {
        if (fileType === 'Image') {
            return '.jpeg,.jpg,.png,.PNG';
        }
        if (fileType !== '2D' && fileType !== '3D') {
            return '.pdf';
        }
        return '*/*';
    };

    const handleFileUpload = (event, fileType) => {
        const file = event.target.files[0];
        if (file) {
            setResource((prevData) => ({
                ...prevData,
                [fileType.toLowerCase().replace(/\s+/g, '')]: file,
            }));
            setRows((prevData) =>
                prevData.map((row) => {
                    if (row.type === fileType) {
                        return {
                            ...row,
                            resource: file.name,
                            size: `${(file.size / 1024).toFixed(2)} KB`,
                            extension: file.name.split('.').pop(),
                        };
                    }
                    return row;
                })
            );
        }
    };

    const handleRemove = (fileType) => {
        setResource((prevData) => ({
            ...prevData,
            [fileType.toLowerCase().replace(/\s+/g, '')]: null,
        }));

        setRows((prevData) =>
            prevData.map((row) => {
                if (row.type === fileType) {
                    return {
                        ...row,
                        resource: '--',
                        size: '--',
                        extension: '--',
                    };
                }
                return row;
            })
        );
    }

    return (
        <>
            <Dialog open={dialogOpen} fullWidth maxWidth="sm">
                <DialogTitle>Save Url</DialogTitle>
                <DialogContent>
                    <Box style={{ marginTop: 10 }}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Website URL</InputLabel>
                            <OutlinedInput
                                label="Website URL"
                                id="standard-adornment-password"
                                type='text'
                                onChange={(e) => {
                                    const newUrl = e.target.value;
                                    const urls = newUrl.split(',').map((url) => url.trim());
                                    const isValidUrls = urls.every((url) => {
                                        try {
                                            new URL(url);
                                            return true;
                                        } catch (e) {
                                            return false;
                                        }
                                    });
                                    setIsValid(isValidUrls);
                                    setUrl(e.target.value);
                                }}
                            />
                            <FormHelperText>
                                {isValid
                                    ? 'Enter multiple URLs separated by commas.'
                                    : 'Invalid URL format. Please check the URLs.'}
                            </FormHelperText>
                        </FormControl>
                        {rows.find((f) => f.type === 'URL').resource !== '--' && rows.find((f) => f.type === 'URL').resource?.split(',')?.map((a) => (
                            <Box style={{ display: 'flex', justifyContent: 'space-between', margin: 10, alignItems: 'center' }}>
                                <Typography variant="body1">{a}</Typography>
                                <Tooltip title="remove website url">
                                    <IconButton onClick={() => {
                                        const existingURL = rows.find((f) => f.type === 'URL').resource;
                                        let updatedURL = existingURL.replace(new RegExp(`,${a}$`), "").trim();
                                        if (existingURL.startsWith("https://")) {
                                            updatedURL = existingURL.replace(/^https:\/\/[^,]+,?/, '').trim();
                                        }
                                        if (updatedURL.startsWith(',')) {
                                            updatedURL = updatedURL.substring(1).trim();
                                        }
                                        if (updatedURL[0] === ',') {
                                            updatedURL = updatedURL.slice(1).trim();
                                        }
                                        setResource((prevData) => ({
                                            ...prevData,
                                            url: updatedURL,
                                        }));
                                        setRows((prevData) =>
                                            prevData.map((row) => {
                                                if (row.type === 'URL') {
                                                    const resourceValue = updatedURL === '' ? '--' : updatedURL;
                                                    return {
                                                        ...row,
                                                        resource: resourceValue,
                                                        extension: resourceValue !== '--' ? 'URL' : '--',
                                                    };
                                                }
                                                return row;
                                            })
                                        );
                                    }}>
                                        <RemoveCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={() => {
                        if (url) {
                            if (isValid) {
                                const existingURL = rows.find((f) => f.type === 'URL').resource;
                                setResource((prevData) => ({
                                    ...prevData,
                                    url: existingURL !== '--' ? `${existingURL},${url}` : url,
                                }));
                                setRows((prevData) =>
                                    prevData.map((row) => {
                                        if (row.type === 'URL') {
                                            return {
                                                ...row,
                                                resource: existingURL !== '--' ? `${existingURL},${url}` : url,
                                                extension: 'URL',
                                            };
                                        }
                                        return row;
                                    })
                                );
                                setUrl(null);
                            }
                            else {
                                showNotification('Invalid URL format. Please check the URLs', 'error');
                            }
                        }
                        setDialogOpen(false)
                    }}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            {(['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && detailsData?.is_customer_product) && (
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={detailsData.converToCatalog}
                                onClick={async (e) => {
                                    setDetailsData((prevData) => ({
                                        ...prevData,
                                        converToCatalog: e.target.checked,
                                    }));
                                    if (e.target.checked) {
                                        try {
                                            const response = await apiRequest('get', `/product/product-sku/${detailsData?.categoryid}/${detailsData?.subCategoryid}`);
                                            if (response?.data) {
                                                setSkuNo(response?.data?.data?.numaric_sku);
                                            }
                                        } catch (error) {
                                            showNotification(error?.response?.data.error || error.message, 'error');
                                        }
                                    }
                                }}
                            />}
                        label="Convert to catalog item"
                    />
                </FormGroup>
            )}
            <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                <TableContainer>
                    <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                        <TableHead>
                            <TableRow>
                                <Cell>Extension</Cell>
                                <Cell>Type</Cell>
                                <Cell>Resource</Cell>
                                <Cell>Size</Cell>
                                <Cell>Action</Cell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                const is2D = row.type === '2D';
                                const is3D = row.type === '3D';
                                const isAdmin = ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code);

                                // Determine if the current plan allows access based on type
                                const hasAccess2D = is2D && (isAdmin || TwoDAccess.includes(currentPlanId));
                                const hasAccess3D = is3D && (isAdmin || ThreeDAccess === currentPlanId);
                                const hasAccessOtherTypes = !is2D && !is3D; 

                                // Calculate the button's disabled state based on the conditions
                                const isButtonDisabled = !(hasAccess2D || hasAccess3D || hasAccessOtherTypes);

                                return (
                                    <TableRow key={index}>
                                        <Cell>
                                            <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                                {(row.extension !== '--' && row?.type === 'Image') ? (
                                                    <img src="/images/gallary.png" alt="blog img" style={{ width: 20 }} />
                                                ) : (row.extension !== '--' && row?.type === '2D') ? (
                                                    <img src="/images/autocad.png" alt="blog img" style={{ width: 20 }} />
                                                ) : (row.extension !== '--' && row?.type === '3D') ? (
                                                    <img src="/images/ravit.jpeg" alt="blog img" style={{ width: 20 }} />
                                                ) : (row.extension !== '--' && row?.type === 'URL') ? (
                                                    <img src="/images/URL.png" alt="blog img" style={{ width: 20 }} />
                                                ) : row.extension !== '--' && (
                                                    <img src="/images/pdf.svg" alt="blog img" style={{ width: 15 }} />
                                                )}
                                                {row.extension}
                                            </Box>
                                        </Cell>
                                        <Cell>{row.type}</Cell>
                                        <Cell>
                                            {row.type === 'URL' ? (
                                                row?.resource !== '--' && row?.resource?.split(',').map((a) => (
                                                    <>
                                                        <Tooltip title={a}>
                                                            <a href={a} target="_blank" rel="noreferrer">{a.slice(0, 50)}</a>
                                                        </Tooltip>
                                                        <br />
                                                    </>
                                                ))
                                            ) :
                                                row.resource}
                                        </Cell>
                                        <Cell>{row.size}</Cell>
                                        <Cell>
                                            {row.type === 'URL' ? (
                                                <IconButton onClick={() => setDialogOpen(true)} style={{ padding: 0 }}>
                                                    <LinkIcon />
                                                </IconButton>
                                            ) : (
                                                row.extension !== '--' ? (
                                                    <IconButton onClick={() => handleRemove(row.type)} style={{ padding: 0 }}>
                                                        <RemoveCircleOutlineIcon />
                                                    </IconButton>
                                                ) : (
                                                    <IconButton
                                                        component="label"
                                                        style={{ padding: 0 }}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <CloudUploadIcon />
                                                        <VisuallyHiddenInput
                                                            type="file"
                                                            onChange={(event) => {
                                                                handleFileUpload(event, row.type)
                                                            }}
                                                            accept={getAcceptType(row.type)}
                                                        />
                                                    </IconButton>
                                                )
                                            )}
                                        </Cell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}